import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AngularMaterialModule} from '../scss/angular-material/angular-material.module';
import {SharedModule} from '../shared/shared.module';
import {GroupedPanelOutsputsComponent} from './components/grouped-list/grouped-list.component';
import {PanelOutputItemComponent} from './components/panel-output-item/panel-output-item.component';
import {PanelOutputsShellComponent} from './components/panel-outputs-shell/panel-outputs-shell.component';
import {SelectedGroupComponent} from './components/selected-group/selected-group.component';
import {SelectedOutputComponent} from './components/selected-output/selected-output.component';
import {PanelOutputsRoutingModule} from './panel-outputs-routing.module';

@NgModule({
  declarations: [
    PanelOutputsShellComponent,
    GroupedPanelOutsputsComponent,
    PanelOutputItemComponent,
    SelectedGroupComponent,
    SelectedOutputComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    AngularMaterialModule,
    PanelOutputsRoutingModule
  ],
  exports: [
    PanelOutputsShellComponent
  ]
})
export class PanelOutputsModule {
}
